import React from 'react';
import PropTypes from "prop-types";
import {
  Player,
  ControlBar,
  ReplayControl,
  ForwardControl,
  CurrentTimeDisplay,
  TimeDivider,
  PlaybackRateMenuButton,
  VolumeMenuButton
} from 'video-react';
import 'video-react/dist/video-react.css'; // import css

export default function SectionVideo({url, poster, title, subtitle}){
  return (
    <div>
      <h1>{title}</h1>
      <h4>{subtitle}</h4>

    <Player poster={poster}>
      <source src={url} />
      <ControlBar>
        <ReplayControl seconds={10} order={1.1} />
        <ForwardControl seconds={30} order={1.2} />
        <CurrentTimeDisplay order={4.1} />
        <TimeDivider order={4.2} />
        <PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7.1} />
        <VolumeMenuButton />
      </ControlBar>
    </Player>
    </div>
  );
};

SectionVideo.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  poster: PropTypes.object.isRequired
}